module.exports = __webpack_public_path__ + "static/media/38-8.1e4c9c07.mp3";